/* eslint-disable import/prefer-default-export */
import Hls, { ErrorData } from 'hls.js';

/**
 * エラー扱いにするかどうか
 * エラー内容：https://github.com/video-dev/hls.js/blob/master/docs/API.md#network-errors
 * @param data エラーデータ
 * @returns true:エラー扱い/no:エラー扱いしない
 */
export const isTreatError = (data: ErrorData): boolean => {
  // buffer不足 & 致命的なエラーじゃなければエラー扱いにしない
  // このエラー時は、音声再生が完全に止まらず、すぐに再生が再開されるため
  if (data.details === Hls.ErrorDetails.BUFFER_STALLED_ERROR && !data.fatal) {
    return false;
  }

  return true;
};
